import { render, staticRenderFns } from "./_brands.vue?vue&type=template&id=1bc5cbb4"
import script from "./_brands.vue?vue&type=script&lang=js"
export * from "./_brands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports